import { ComparatorReturns } from '@list-store';
export function baseGroupingComparator<T extends string>(
    leftStatus: T,
    rightStatus: T,
    getSortValue: (header: T) => number
): ComparatorReturns {
    const left = getSortValue(leftStatus);
    const right = getSortValue(rightStatus);

    if (left === right) {
        return 0;
    }
    if (left < right) {
        return -1;
    }
    return 1;
}
